





































































































































































































































import VuePdfEmbed from "vue-pdf-embed";
import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Pdf from "@/components/Pdf.vue";
import { BIcon, BIconBoxArrowRight, BIconUpload } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Galery from "@/components/Galery.vue";
import Footer from "@/components/Footer.vue";
import SpellingInterractExe from "./ProSpelling/SpellingInterractExe.vue";
@Component({
  components: {
    Galery,
    VuePdfEmbed,
    Header,
    Menu,
    Pdf,
    BIcon,
    BIconBoxArrowRight,
    BIconUpload,
    NextPrevBtn,
    Footer,
    SpellingInterractExe
  }
})
export default class ProSpelling extends Vue {
  protected ecriplus: string[] = [
    "/picture_ecriplus/ecriplus-1.png",
    "/picture_ecriplus/ecriplus-2.png",
    "/picture_ecriplus/ecriplus-3.png",
    "/picture_ecriplus/ecriplus-4.png",
    "/picture_ecriplus/ecriplus-5.png"
  ];
  protected nxtprevProSpelling = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail3.png",
    NextImage: "/thumbnail7.png",
    PrevLink: "/Ecrit_Pro/Strategie",
    NextLink: "/Ecrit_Pro/Exemples"
  };
}
